import { PureLightTheme } from "../../styles/theme"

export const TypTitle = {
  padding: "0px 20px",
  mb: 2,
  [PureLightTheme.breakpoints.down('md')]: {
    padding: 0,
    fontSize: '21px',
  }
}

export const SearchStack = { 
  alignItems: 'center', 
  [PureLightTheme.breakpoints.down('md')]: {
    paddingBottom: 2,
  }
}

export const TextFieldBox = {
  flex: 1,
}

export const MenuPaperProps = {
  border: 'none', 
  borderRadius: '12px',
}

export const MenuListProps = {
  padding: 0,
}

export const StackStyle = {
  justifyContent: 'center',
  gap: 2, 
  padding: '0px 16px 0px 16px', 
  '@media (max-width:1200px)': {
    gap: 1,
    padding: '0px 12px 0px 12px', 
  },
}

export const MainBox = {
  minWidth: 0,
  mt: '50px',
  maxWidth: '736px',
  width: '100%',
  [PureLightTheme.breakpoints.down('md')]: {
    mt: '15px',
  }
}

export const SideBox = {
  mt: '16px', 
  position: 'sticky', 
  top: 77, 
  alignSelf: 'flex-start',
  height: 'calc(100vh - 77px - 16px)', // отступ сверху и снизу 
}
